// jotai
import { useAtomValue } from "jotai";
import { AppAtoms } from "../lib/store";

import { headerColor } from "../config/const";

const Header = () => {
  const layoutConfig = useAtomValue(AppAtoms.layoutConfig);
  return (
    <>
      {layoutConfig.site_color === "" ? (
        <></>
      ) : (
        <header
          style={{
            borderBottomColor: headerColor[layoutConfig.site_color],
          }}
        >
          <div className="logo">
            <img src={layoutConfig.header_location_logo} alt="ロゴ" />
          </div>
        </header>
      )}
    </>
  );
};

export default Header;
